export const ALENDUM = {
    url:
        'https://brandfactory.alendumerp.mx/brandfprod/ws/com.alendum.custom.api.',
    authorization: 'Basic QnJhbmRmYWN0b3J5OkJyYW5kZmFjdG9yeTIwMjQ=',
    SO_PEDIDO_DE_VENTA: '1AFC4BDBB0394E7EA3AF0D472BB813E5',
    FP_TRANSFERENCIA_DE_FONDOS: '4C0737CBBE5845EE8E21B4519FCD8188',
    TARIFA_VENTAS_MXN: '0BB1D45F3F3C47FA82635786E09E2B56',
    PREPARACION_A: 'A',
    FACTURACION_D: 'D',
    IMPUESTO_VENTAS: '732EFDF48B9D4940AE9C83250905BEC8'
};
